import { EventName } from '@lit/react';
import { BlocksList } from 'blocks-nextjs/blocks-web-components/components/list/list';
import { BlocksSelectEvent } from 'blocks-nextjs/blocks-web-components/events';
import React from 'react';
import { createComponent } from '../CustomWrapper/CustomWrapper';
export const CatList = createComponent({
  react: React,
  tagName: 'cat-list',
  elementClass: BlocksList,
  events: {
    onBlSelect: 'bl-select' as EventName<BlocksSelectEvent>
  }
});
